import { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { Star, EyeOff, Eye, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminReviews() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const toggle = async (id) => { await api.put(`/admin/reviews/${id}/hide`); load(); };
  const remove = async (id) => {
    if (!window.confirm("Delete this review permanently?")) return;
    await api.delete(`/admin/reviews/${id}`);
    toast.success("Review deleted");
    load();
  };

  return (
    <div>
      <h1 className="font-display font-bold text-xl mb-6" data-testid="admin-reviews-title">REVIEW MODERATION</h1>
      <div className="space-y-2">
        {reviews.length === 0 && <p className="text-sm text-[var(--forge-dim)]">No reviews yet.</p>}
        {reviews.map((r) => (
          <div key={r.id} className={`forge-card !transform-none p-4 ${r.hidden ? "opacity-50" : ""}`} data-testid={`admin-review-${r.id}`}>
            <div className="flex items-center gap-2 text-sm">
              <span className="font-semibold">{r.user_name}</span>
              <span className="text-[var(--forge-gold)] flex items-center gap-0.5">{r.rating}<Star size={12} className="fill-[var(--forge-gold)] text-[var(--forge-gold)]" /></span>
              {r.hidden && <span className="text-xs text-[var(--forge-gold)]">HIDDEN</span>}
              <div className="ml-auto flex gap-1">
                <button data-testid={`hide-review-${r.id}`} onClick={() => toggle(r.id)} className="p-1.5 text-[var(--forge-dim)] hover:text-[var(--forge-gold)]" title={r.hidden ? "Unhide" : "Hide"}>
                  {r.hidden ? <Eye size={15} /> : <EyeOff size={15} />}
                </button>
                <button data-testid={`delete-review-${r.id}`} onClick={() => remove(r.id)} className="p-1.5 text-[var(--forge-dim)] hover:text-red-400"><Trash2 size={15} /></button>
              </div>
            </div>
            {r.text && <p className="text-sm text-[var(--forge-dim)] mt-1">{r.text}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
